// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"f1b72b6e","377":"9fa83e9f","687":"205b563e"}[chunkId] + ".chunk.css";
};